export default __webpack_public_path__ + "static/media/motorola.a4250790.svg";